/**
 * Les montants circulent en centimes (l'API ne calcule jamais en flottant) :
 * le formatage est le seul endroit où l'on repasse en euros.
 */
export function formatCents(cents: number, locale: string): string {
  return new Intl.NumberFormat(locale === 'en' ? 'en-GB' : 'fr-FR', {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: 0,
  }).format(cents / 100)
}
